export interface TimelineNode {
  header: string;
  headerExtra?: string;
  headerExtraImg?: string;
  date?: Date;
  highlightedInfoIcon?: string;
  highlightedInfoLabel?: string;
  description: string[];
  state: TimelineNodeState;
}

export enum TimelineNodeState {
  COMPLETED = 0,
  ACTIVE = 1,
  INCOMPLETED = 2,
}
